import Vue from 'vue/dist/vue.esm.js';
import {formatPrice} from '../utility/formatPrice'
import {parseCartResponse} from '../utility/parseCartResponse'

Vue.component('cart-icon', {
    template: `#cart-icon`,
    delimiters: ['[[', ']]'],
    props: {
        initialCart: {
            required: false,
            type: [String, Object],
            default: () => ({
                quantity: 0,
                total: 0,
                promocode: null,
                rows: [],
                id: null,
                hash: null,
                totalPriceAfterDiscount: 0,
                originalTotal: 0,
                discount: 0,
                loyaltyProgramDiscount: 0,
                totalPromocodeDiscount: 0,
                haveFreeDeliveryDiscount: false
            })
        },
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        exchangeRate: {
            required: true,
            type: String,
        },
        exchangeRateMode: {
            required: true,
            type: String,
        },
        convertMode: {
            required: true,
            type: String,
        },
        showEurFirst: {
            required: false,
            type: String,
            default: '0'
        }
    },

    mounted() {
        EventManager.listen('item-added', this.itemAdded);
        EventManager.listen('cart-updated', this.itemAdded);
        EventManager.listen('item-removed', this.itemRemoved);
    },

    data() {
        const defaultCart = {
            quantity: 0,
            total: 0,
            promocode: null,
            rows: [],
            id: null,
            hash: null,
            totalPriceAfterDiscount: 0,
            originalTotal: 0,
            discount: 0,
            loyaltyProgramDiscount: 0,
            totalPromocodeDiscount: 0,
            haveFreeDeliveryDiscount: false
        };
        
        // Handle both JSON string and object formats
        let cart = defaultCart;
        if (this.initialCart) {
            if (typeof this.initialCart === 'string') {
                try {
                    cart = JSON.parse(this.initialCart) || defaultCart;
                } catch (e) {
                    console.warn('Failed to parse cart JSON:', e);
                    cart = defaultCart;
                }
            } else if (typeof this.initialCart === 'object' && this.initialCart !== null) {
                cart = this.initialCart;
            }
        }
        
        return {
            cart: cart
        }
    },

    methods: {
        formatDualPrice(price) {
            return formatPrice(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, false, this.showEurFirst);
        },
        itemAdded(data) {
            const cart = parseCartResponse(data);
            if (cart) {
                this.cart = cart;
            }
        },

        itemRemoved(data) {
            const cart = parseCartResponse(data);
            if (cart) {
                this.cart = cart;
            }
        },

        cartUpdated(data) {
            const cart = parseCartResponse(data);
            if (cart) {
                this.cart = cart;
            }
        },

        removeRow(rowId, removeItemUrl) {
            this.buildAjax(rowId, removeItemUrl);
        },

        formattedPrice(price) {
            return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(price);
        },
        iconClicked() {
            EventManager.fire('cart-widget-open');
        },
    },

    computed: {
        total() {
            return this.formattedPrice(this.cart?.total || 0)
        }
    }
});
